// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    instanceString: 'TRAINING',
    msalConfig: {
        clientId: '04ee73e6-4d07-40c8-adbd-a35a78057884',
        authority: 'https://login.microsoftonline.com/26a873c3-b6e8-4210-b79a-b04ff987154e/', // siopen-r-net tenant: 26a873c3-b6e8-4210-b79a-b04ff987154e
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin + '/',
        endpoints: {
            'https://graph.windows.net/siopen-r-net.org': ['00000002-0000-0000-c000-000000000000/.default'],
            'https://starimost-itest.siopen-r-net.org': ['cbe19546-44ca-449f-8ee7-c0344b4293a7/.default'],
            'https://trial-services.eupid.eu/EUPID': ['7c998b47-e72f-4a86-afc5-79c8c82ab62a/.default'],
            'https://trial-services.eupid.eu/Helper': ['7c998b47-e72f-4a86-afc5-79c8c82ab62a/.default'],
        }
    },
    aad: {
        graphApiBaseUrl: 'https://graph.windows.net/siopen-r-net.org',
        apiVersion: '?api-version=1.6',
        groupPrefix: 'TRAIN-',
        srnUserGroupId: ''  //needed for userdcptable at the moment - should be removed!
    },
    lines: {
        ssoServiceUrl: 'https://test.lines.siopen-r-net.org/service_saml/acs'
    },
    hrnbl15n: {
        ssoServiceUrl: 'https://hrnbl1-training.siopen-r-net.org/service_saml/acs'
    },
    eupidServiceBaseUrl: 'https://trial-services.eupid.eu',
    starimostBaseUrl: 'https://starimost-itest.siopen-r-net.org',
    omsBaseUrl: 'https://trials-training.siopen-r-net.org',
    veritasBaseUrl: 'https://trials-training.siopen-r-net.org',
    siopenrnetBaseUrl: 'https://test.siopen-r-net.org',
    ltiBaseUrl: 'https://lti-test.siopen-r-net.org/ ',
    hashConfig: {
        hmacSHA512: {
            hmacKey: 'uxgsDhhaB88721'
        },
        argon2: {
            salt: new Uint8Array([163,221,11,125,106,18,188,111,83,48,79,227,8,199,252,56,3,159,34,192,117,36,129,33,26,159,182,183,231,143,204,73]),
            keylen: 64,
            opsLimit: 3,
            memLimit: 102400
        }
    }
};
